import React from 'react'
import styles from '../styles.module.css'


const ENTITIES = [
  {grade: 'основного', parallel: '9'},
  {grade: 'среднего', parallel: '11'}
]

const Table = ({
  data,
  reportParams,
  organizations,
  orgName
}) => {

  
  if (!data) return null;

  const renderRow = (subjects, parallel) => (org) => {
    const mode9 = parallel === '9'
    return (
      <tr>
        <th className={styles.orgName}>{organizations[org.idorganization]}</th>
        <td>{org.s_count}</td>
        {subjects.map(subject => {
          const gradeData = data.grades?.get(parallel)?.get(subject)?.get(org.idorganization)
          const grade = gradeData && parseFloat(gradeData.grade.replace(',', '.')).toFixed(2)
          return <td>{grade}</td>
        })}
        {!subjects.length && <td></td>}
        {mode9 && <td>{org.e_count}</td>}
        {mode9 && <td>{org.r_count}</td>}
        {!mode9 && <td>{org.count_100}</td>}
        {!mode9 && <td>{org.count_90}</td>}
        {!mode9 && <td>{org.count_80}</td>}
      </tr>
    )
  }

  return (
    <>
        <h5 className={styles.descrTitle}>Форма №1/СВУ</h5>
        {reportParams.org !== '0' &&
          <h3 className={`text-center mb-2 mt-5 ${styles.title}`}>{orgName}</h3>
        }
        {ENTITIES.map(({grade, parallel}) => {
          const gradesParallel = data?.grades?.get(parallel)
          const countsParallel = data?.counts?.get(parallel)
          const subjects = gradesParallel ? [...gradesParallel.keys()] : []
          const organizations = countsParallel ? [...countsParallel.values()] : []
          const mode9 = parallel === '9'
          const averageTitle = mode9 ? 'Средняя оценка сдачи ОГЭ по предметам' : 'Средний балл сдачи ЕГЭ по предметам'
          return (
            <div className={styles.tableBlock} key={parallel}>
              <h3 className={`text-center mb-2 mt-5 ${styles.title}`}>
                {`Сведения о результатах сдачи государственной итоговой аттестации  по образовательным программам ${grade} общего образования`}
              </h3>
              {organizations.length
                ? (
                <table className={styles.mainTable} id={`giaTable_${parallel}`}>
                  <thead>
                    <tr>
                      <th rowSpan={2} className={styles.orgName}>Название образовательной организации</th>
                      <th rowSpan={2} className={styles.vertical}>Численность выпускников, чел</th>
                      {subjects.length
                        ? <th colSpan={subjects.length}>{averageTitle}</th>
                        : <th rowSpan={2}>{averageTitle}</th>}
                      {mode9 && <th rowSpan={2} className={styles.vertical}>Количество обучающихся, получивших аттестат с отличием</th>}
                      {mode9 && <th rowSpan={2} className={styles.vertical}>Количество обучающихся, оставленных на повторное обучение</th>}
                      {!mode9 && <th rowSpan={2} className={styles.vertical}>Количество обучающихся, набравших 100 баллов</th>}
                      {!mode9 && <th rowSpan={2} className={styles.vertical}>Количество обучающихся, набравших от 90 до 99 баллов</th>}
                      {!mode9 && <th rowSpan={2} className={styles.vertical}>Количество обучающихся, набравших от 80 до 89 баллов</th>}
                    </tr>
                    {subjects.length > 0 && (
                      <tr>
                        {subjects.map(subject => <th key={subject} className={styles.vertical}>{subject}</th>)}
                      </tr>
                    )}
                  </thead>
                  <tbody>
                    {organizations.map(renderRow(subjects, parallel))}
                  </tbody>
                </table>
              ) : (
                <div className={styles.noData}>Данные отсутствуют</div>
              )}
            </div>
          )
        })}
    </>
  )
}

export default Table